import React from 'react';
import Instructions from './Instructions';
import Social from './Social';
import PdfEu from './PdfEu';
import PdfNa from './PdfNa';
import { ReactComponent as Logo } from '../images/ui/logo.svg';
import { ReactComponent as LogoBottom } from '../images/ui/logo-bottom.svg';
import { ReactComponent as Contact } from '../images/ui/contact.svg';

export default function Sidebar(props) {
  return (
    <>
      <div className='sidebar user-select-none p-4 me-lg-3'>
        <div className='d-flex align-items-center'><div className='logo'><button onClick={props.onClick}><Logo className='logo' /></button></div><h1 className='fs-4 ms-3 mb-0'><a className='text-white text-decoration-none' href="https://poolsidebycgt.com/">Poolside Visualizer by CGT</a></h1></div>
        <hr className='border-top border-2 mt-5 border-white opacity-75 w-75' />
        {props.liner.liner_name ? (
          <div className='liner-desc mt-4 ps-4'><h2 className='fs-4'>{props.liner.liner_name}</h2><div className='description my-3' dangerouslySetInnerHTML={{ __html: props.liner.liner_desc }} /></div>
        ) : (
          <Instructions classes='ps-4 my-3' />
        )}
        {(props.liner.liner_base) && (
          <div className='liner-base mt-4 ps-4'>Base Film: {props.liner.liner_base}</div>
        )}
        {props.liner.liner_cat1 && props.liner.liner_cat1.startsWith('aqua') ? <div className='liner-categories mt-4 ps-4'> <img alt={props.liner.liner_cat1} src={'images/categories/' + props.liner.liner_cat1 + '-w.png'} /> </div> : props.liner.liner_cat1 ? <div className='liner-categories mt-4 ps-4'> {props.liner.liner_cat1} </div> : null}
        {props.liner.liner_cat2 && props.liner.liner_cat2.startsWith('aqua') ? <div className='liner-categories mt-4 ps-4'> <img alt={props.liner.liner_cat2} src={'images/categories/' + props.liner.liner_cat2 + '-w.png'} /> </div> : props.liner.liner_cat2 ? <div className='liner-categories mt-4 ps-4'> {props.liner.liner_cat2} </div> : null}
        {(props.liner.liner_ico1) && (
          <img className='liner-icons mt-4 ps-4' alt={props.liner.liner_name} src={props.dataUrl + props.liner.liner_ico1} />
        )}
        {(props.liner.liner_ico2) && (
          <img className='liner-icons mt-4 ps-4' alt='Anti-Slip' src={props.dataUrl + props.liner.liner_ico2} />
        )}
        {(props.collection === '2' && props.deck.deck_id && !props.showLiners && !props.showDecks) && (
          <PdfEu shape={props.shape} liner_info={props.liner} deck={props.deck} siteUrl={props.siteUrl} />
        )}
        {(props.collection === '148' && props.deck.deck_id && !props.showLiners && !props.showDecks) && (
          <PdfNa shape={props.shape} liner_info={props.liner} deck={props.deck} siteUrl={props.siteUrl} spacing={65} headingSize={8} topSpacing={10} textSize={9} textSpacing={12} first={70} second={238} third={406} initialY={649} linkSpace={65} />
        )}
        <div className='ps-4 mt-5'><a className='text-white text-decoration-none' href='https://poolsidebycgt.com/about/#contact'><Contact alt='Contact Us' /> Contact Us</a></div>
        <div className='row ps-4 justify-content-start mt-3 mb-5 g-1'><Social /></div>

      </div><a href='https://poolsidebycgt.com/'><LogoBottom className='logo-bottom img-fluid float-end px-5 px-xl-4 my-5' /></a>
    </>
  );
}
